// Front
// Authentication Module
import { rootReducer } from "saga-slice";
import authModule from "./sagas/authSlice";
import productSlice from "./sagas/productSlice";
import saleModule from "./sagas/saleSlice";
import stockSlice from "./sagas/stockSlice";
import supplierSlice from "./sagas/supplierSlice";
import refundSlice from "./sagas/refundSlice";
import inventorySlice from "./sagas/inventorySlice";
import invoiceSlice from "./sagas/invoiceSlice";
import devisSlice from "./sagas/devisSlice";
import supplierProductSlice from "./sagas/supplierProductSlice";
import purchaseModule from "./sagas/purchaseSlice";
import deliverySlice from "./sagas/deliveryNoteSlice";
import clientSlice from "./sagas/clientSlice";
import receiptNoteModule from "./sagas/receiptNoteSlice";
import invoiceSupplierSlice from "./sagas/invoiceSupplierSlice";
import categorySlice from "./sagas/categorySlice";
import unitesSlice, { unitesActions } from "./sagas/unitesSlice";
import commandeSlice from "./sagas/commandeSlice";
import entrepotSlice from "./sagas/entrepotSlice";
import transporteurSlice from "./sagas/transporteurSlice";
import reglementModule from "./sagas/reglementSlice";
import lotSlice from "./sagas/lotSlice";
import mouvementStockSlice from "./sagas/mouvementStockSlice";
import customerReturnSlice from "./sagas/customerReturnSlice";
import comptabiliteSlice from "./sagas/comptabiliteSlice";
import soldeSlice from "./sagas/soldeSlice";
import reglementFournisseurModule from "./sagas/reglementFournisseurSlice";
import retourFournisseurSlice from "./sagas/retourFournisseurSlice";
import expenseSlice from "./sagas/expenseSlice";
import commercialSlice from "./sagas/commercialSlice";
import commissionPlanSlice from "./sagas/commissionPlanSlice";
import userSlice from "./sagas/userSlice";
import dalaSlice from "./sagas/dalaSlice";
import companySlice from "./sagas/companySlice";

const modules = [authModule, productSlice, saleModule, stockSlice, 
    invoiceSlice,devisSlice,supplierProductSlice,supplierSlice, 
    purchaseModule,deliverySlice, clientSlice, stockSlice, refundSlice, 
    inventorySlice, receiptNoteModule, invoiceSupplierSlice, categorySlice, unitesSlice,
    commandeSlice, entrepotSlice, transporteurSlice, reglementModule, 
    lotSlice, mouvementStockSlice, customerReturnSlice, comptabiliteSlice, 
    soldeSlice, reglementFournisseurModule, retourFournisseurSlice,
    expenseSlice, commercialSlice, commissionPlanSlice, userSlice, dalaSlice, companySlice
];

const appReducer = rootReducer(modules, {
  
});

export default appReducer;
